export const TRANSLATION_PATH = (route) => {
  return `components.application.settings.user.userAccountSettings.${route}`;
};
